export default __webpack_public_path__ + "static/azalea-beet-salad-f4e1b2a80b7f8837b8f88441361d2d0e.jpg";